import { DualPrice, Price, SinglePrice, formatPrice } from 'modules/proposals';
import React from 'react';

interface Props {
  currency: string;
  discountAmount: number;
  exchangeRate?: number;
  dualCurrency?: string;
  ISOCountry?: string;
}

export const DiscountSegmentPrice: React.FC<Props> = ({
  currency,
  discountAmount,
  exchangeRate,
  dualCurrency = 'eur',
  ISOCountry,
}) => (
  <Price
    currency={currency}
    dualCurrency={dualCurrency}
    customExchangeRate={exchangeRate}
    dualPriceElement={
      <DualPrice className="segment-prices__price">
        <p className="t-eta">
          {formatPrice(-discountAmount, currency, ISOCountry)}
        </p>
        {exchangeRate && (
          <p className="o-60 text--xxs__responsive">
            {formatPrice(
              -discountAmount * exchangeRate,
              dualCurrency,
              ISOCountry,
            )}
          </p>
        )}
      </DualPrice>
    }
    singlePriceElement={
      <SinglePrice className="t-eta">
        {formatPrice(-discountAmount, currency, ISOCountry)}
      </SinglePrice>
    }
  />
);
